export const SET_ANSWER = 'SET_ANSWER'
export const SET_ANNEX = 'SET_ANNEX'
export const CLEAR_ANSWERS = 'CLEAR_ANSWERS'
export const CLEAR_ANNEXES = 'CLEAR_ANNEXES'
export const SET_USER = 'SET_USER'
export const SET_EVALUATION = 'SET_EVALUATION'
